import { domAnimation, LazyMotion, m } from 'motion/react'
import React from 'react'

import Logo from '@/assets/logo.webp'

interface CheckinLayoutProps {
  children: React.ReactNode
}

export function CheckinLayout({ children }: CheckinLayoutProps) {
  return (
    <LazyMotion features={domAnimation}>
      {/* Fixed background — stays in place during scroll */}
      <div className="fixed inset-0 bg-[#eb9fa5]">
        <div className="botanical-bg absolute inset-0 opacity-20" />
        <div className="floral-overlay opacity-[0.03]" />
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <m.div
            animate={{
              scale: [1, 1.15, 1],
              opacity: [0.3, 0.5, 0.3],
              x: [0, 20, 0],
              y: [0, 15, 0],
            }}
            transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
            className="bg-blush-soft absolute -top-32 -left-32 size-125 rounded-full blur-[100px]"
          />
          <m.div
            animate={{
              scale: [1, 1.25, 1],
              opacity: [0.15, 0.3, 0.15],
              x: [0, -20, 0],
              y: [0, 30, 0],
            }}
            transition={{
              duration: 15,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 2,
            }}
            className="bg-sage-light/30 absolute top-1/3 -right-32 size-150 rounded-full blur-[120px]"
          />
        </div>
      </div>

      {/* Scrollable content layer */}
      <div className="pb-safe relative z-10 flex h-dvh w-full flex-col items-center overflow-y-auto overscroll-none px-6 py-8 text-[#344C3D]">
        <div className="flex shrink-0 flex-col items-center gap-4 pt-12">
          <img
            draggable={false}
            src={Logo}
            alt="OA & KOI Wedding Logo"
            className="size-full h-24 object-contain brightness-0 invert"
          />
        </div>

        <div className="w-full max-w-lg pt-4 pb-20">{children}</div>
      </div>
    </LazyMotion>
  )
}
